import googleAnalytics, { gaActionTypes, gaCategoryTypes, gaLabelTypes } from './GoogleAnalytics';

const messageSend = () => {
    googleAnalytics.eventInit(gaActionTypes.messages.sent, gaCategoryTypes.message);
};

const messageReceived = () => {
    googleAnalytics.eventInit(gaActionTypes.messages.received, gaCategoryTypes.message);
};

const userLogin = (userId = '') => {
    googleAnalytics.eventInit(gaActionTypes.user.login, gaCategoryTypes.user, `${gaLabelTypes.successful}. UserId=${userId}`);
};

const userLogout = (userId = '') => {
    googleAnalytics.eventInit(gaActionTypes.user.logout, gaCategoryTypes.user, `UserId=${userId}`);
};

const userSignUp = (userId = '') => {
    googleAnalytics.eventInit(gaActionTypes.user.signup, gaCategoryTypes.user, `UserId=${userId}`);
};

const userDeleted = (userId = '') => {
    googleAnalytics.eventInit(gaActionTypes.user.delete, gaCategoryTypes.user, `UserId=${userId}`);
};

const userStartChat = (advisorId = '') => {
    googleAnalytics.eventInit(gaActionTypes.user.startChat, gaCategoryTypes.user, `AdvisorId=${advisorId}`);
};

const userClickedOnTrialBanner = (title = '') => {
    googleAnalytics.eventInit(gaActionTypes.payments.bannerType, gaCategoryTypes.payments, `BannerTitle=${title}`);
};

const userTriggeredPaymentPopupInChat = (type = '') => {
    googleAnalytics.eventInit(gaActionTypes.payments.triggerPopup, gaCategoryTypes.payments, `PopupType=${type}`);
};

const userClickedOnPaymentPopupButton = (type = '') => {
    googleAnalytics.eventInit(gaActionTypes.payments.popupButtons, gaCategoryTypes.payments, `PaymentType=${type}`);
};

const userClickedOnPaymentProfileButton = (type = '') => {
    googleAnalytics.eventInit(gaActionTypes.payments.profileButtons, gaCategoryTypes.payments, `PaymentType=${type}`);
};

const userClickedOnIssueNotification = () => {
    googleAnalytics.eventInit(gaActionTypes.payments.issueNotification, gaCategoryTypes.payments);
};

const userClickedOnGooglePay = () => {
    googleAnalytics.eventInit(gaActionTypes.payments.submitPayment.googlePay, gaCategoryTypes.payments);
};

const userClickedOnApplePay = () => {
    googleAnalytics.eventInit(gaActionTypes.payments.submitPayment.applePay, gaCategoryTypes.payments);
};

const userSubmitCreditCard = () => {
    googleAnalytics.eventInit(gaActionTypes.payments.submitPayment.creditCard, gaCategoryTypes.payments);
};

const gaEvents = {
    eventMessageSend: () => messageSend(),
    eventMessageReceived: () => messageReceived(),
    eventStartChat: (advisorId) => userStartChat(advisorId),
    login: (userId) => userLogin(userId),
    logout: (userId) => userLogout(userId),
    signUp: (userId) => userSignUp(userId),
    delete: (userId) => userDeleted(userId),
    onTrialBannerClick: (title) => userClickedOnTrialBanner(title),
    openPaymentPopup: (type) => userTriggeredPaymentPopupInChat(type),
    onPaymentPopupBtn: (type) => userClickedOnPaymentPopupButton(type),
    onPaymentProfileBtn: (type) => userClickedOnPaymentProfileButton(type),
    onIssueBtn: () => userClickedOnIssueNotification(),
    onGooglePay: () => userClickedOnGooglePay(),
    onApplePay: () => userClickedOnApplePay(),
    onCreditCardPay: () => userSubmitCreditCard()
};

export { gaEvents };
